import {rolesStorage} from "../../services/rolesStorage";
import defaultI18n from "../../i18nService";
import {
    ADMIN_CONSOLE_BUSINESS_OBJECT,
    CABINET_BUSINESS_OBJECT,
    GUEST_ROLE,
    PERMISSION_LEVEL_BUSINESS_OBJECT
} from "../../constant";

export const getRoles = () => {
    return rolesStorage.getRoles()
        .sort((a, b) => {
            if (a.code === GUEST_ROLE) return -1;
            return 0;
        })
        .sort((a, b) => {
            if (a.code < b.code) { return -1; }
            if (a.code > b.code) { return 1; }
            return 0;
        });
};

export const makeSmallStringInTabletVersion = (stringIn, i18n = defaultI18n) => {
    let result = '';
    if(stringIn === i18n.t('app.page.appRole.businessObjectAndRoles.user_preference')) {
        result = i18n.t('app.page.appRole.businessObjectAndRoles.user_preference');
    } else if(stringIn === i18n.t('app.page.appRole.businessObjectAndRoles.cabinet')) {
        result = i18n.t('app.page.appRole.businessObjectAndRoles.cabinet').split(' ').reverse()[0];
    } else if(stringIn === i18n.t('app.page.appRole.businessObjectAndRoles.admin_console')) {
        const array = i18n.t('app.page.appRole.businessObjectAndRoles.admin_console').split(' ');
        result = array.slice(-2).join(' ');
    } else {
        result = stringIn.split(' ')[0];
    }
    return result;
};

export const getValueOfPermissions = (arrayOfPermissions, entryPoint, key) => {
    let result = false;
    if (arrayOfPermissions.length) {
        entryPoint === CABINET_BUSINESS_OBJECT || entryPoint === ADMIN_CONSOLE_BUSINESS_OBJECT ?
            arrayOfPermissions.forEach(it => it.targetName === entryPoint ? result = it[key] : null) :
            arrayOfPermissions.forEach(it => it.entryPoint === entryPoint ? result = it[key] : null);
    }
    return result;
};

export const handleChangePermission = (checked, role, permissionKey, row) => {
    const preparedData = {...role};
    if (row.level === PERMISSION_LEVEL_BUSINESS_OBJECT) {
        preparedData.permissions.forEach((it) => {
            if (row.entryPoint === it.entryPoint) {
                it[permissionKey] = checked;
            }
        });
    } else {
        preparedData.permissions.forEach((it) => {
            if (row.targetName === it.targetName) {
                it.hasAccess = checked;
            }
        });
    }
    rolesStorage.updateRolePermission(preparedData);
};
